import React from 'react';
import { NumpadIconFive } from './config-numpad-five';
import '../styles/config-title.scss';

interface Props {
	title: string;
	subtitle?: string;
	subtitle2?: string;
}

export const ConfigTitle: React.FunctionComponent<Props> = props => {
	let subtitle2Content: JSX.Element | null = null;
	if (props.subtitle2) {
		const split = props.subtitle2.split('{icon}');
		const innerJsx = split.length === 1 ?
			<>{split[0]}</> :
			<>
				<span>{split[0]}</span>
				<NumpadIconFive />&nbsp;
				<span>{split[5]}</span>
			</>;
		subtitle2Content = <h3 className={'config-title__subtitle2'}>{innerJsx}</h3>;
	}

	return (
		<div className='config-title--wrapper'>
			<h1 className={'config-title__title'}>{props.title}</h1>
			<h2 className={'config-title__subtitle'}>{props.subtitle}</h2>
			<span className={'config-title__subtitle2-wrapper'}>{subtitle2Content}</span>
		</div>
	);
};
